<template>
    <div style="background: grey">
        <div style="margin: 0 0 10px">
            <slot name="actions" v-bind="props.doc">
                <n-button size="tiny" color="black" tag="a" :href="props.doc.link">download</n-button>&nbsp;
                <n-button size="tiny" color="black" tag="a" target="_blank" :href="props.doc.path">open</n-button>
            </slot>
        </div>
        <div v-if="props.doc.link" class="pdf-outer-box" :style="heightStyle">
            <iframe v-if="showGoogleDriveFallback" :src="googleDrivePreviewUrl" width="100%" :height="heightStyle['max-height']" style="border: none" />
            <vue-pdf-embed v-else :id="props.doc.link" :source="props.doc.link" @loading-failed="onLoadingFailed" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useViewPortHeight } from '@/hooks';
import type { IOutputDocument, ICondoFile } from '@condo/domain';
import { getDriveId } from '@condo/domain';
import { NButton } from 'naive-ui';
import { computed, ref } from 'vue';
import VuePdfEmbed from 'vue-pdf-embed';

interface Props {
    doc: Pick<IOutputDocument | ICondoFile, 'link' | 'path'>;
    maxHeight?: string;
}
const props = defineProps<Props>();
const viewportHeight = useViewPortHeight();

const showGoogleDriveFallback = ref(false);

const heightStyle = computed(() => {
    return { 'max-height': props.maxHeight ?? viewportHeight.value };
});

const googleDrivePreviewUrl = computed(() => {
    const driveId = getDriveId({ link: props.doc.link, path: props.doc.path } as any);
    return driveId ? `https://drive.google.com/file/d/${driveId}/preview` : '';
});

const onLoadingFailed = () => {
    if (googleDrivePreviewUrl.value) {
        showGoogleDriveFallback.value = true;
    }
};
</script>

<style scoped>
.vue-pdf-embed :deep(div) {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.vue-pdf-embed :deep(canvas) {
    width: 100% !important;
    height: auto !important;
}
.pdf-outer-box {
    background: grey;
    overflow-y: auto;
    overflow-x: auto;
    padding: 0 10px;
}
</style>
